// extracted by mini-css-extract-plugin
export default {"category":"Category_category__+D1-s","image":"Category_image__FX013","skeleton":"Category_skeleton__txWqq"};